import React, { useState, useRef, useEffect } from "react";

import { endPoints } from "../../constant/Environment";
import { getAllData, getAllFilterData } from "../../Utility/API";
import { Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";

import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

import { Col, Row, Container } from "react-bootstrap";
import { BsExclamationLg } from "react-icons/bs";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

const Deposit = () => {
  const [editData, setEditData] = useState({});

  const [rows, setRows] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalcount, setTotalCount] = useState(1);

  const [userId, setUserId] = useState("");
  const [Transtype, setTransType] = useState("");
  const [username, setuserName] = useState("");
  const [name, setName] = useState("");
  const [email,setEmail] = useState("")
  // Avoid a layout jump when reaching the last page with empty rows.

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const emptyRows = 0;

  useEffect(() => {
    paymentsData(1, filteredData);
  }, []);

  // withdrawl payments get api call
  const paymentsData = async (page, data) => {
    let url = `${endPoints.api.DEPOSIT_TRANSACTIONS}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllFilterData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          let data = response.data;
          setRows(response.data);
          // console.log("data row",response.data.type);

          const ITEMS_PER_PAGE = rowsPerPage;
          setTotalCount(data[0]?.totalcount);
          const totalCount = data[0]?.totalcount;
          const totalPagesCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
          setTotalPages(totalPagesCount);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  let filteredData = {
    userId: userId,
    status: Transtype,
    name: name,
    userName: username,
    email:email
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    paymentsData(newPage + 1, filteredData);
  };

  const handleChangeRowsPerPage = (event, newPage) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
  };

  useEffect(() => {
    paymentsData(page, filteredData);
  }, [rowsPerPage]);

  const refundButton = async (row) => {
    try {
      let url = `${endPoints.api.RETURN_TRANSACTIONS}`;
      let data = {
        id_transaction: row.id_transaction,
        id_user: row.id_user,
        status: 6,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response.status == "success") {
        SuccesToast(response.message);
        paymentsData(page, filteredData);
      } else {
        ErrorToast(response.message);
      }
    } catch (Err) {
      console.log(Err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Deposit Requests
                  </h3>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                {/* <div className="table_search"> */}
                <Row>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Customer ID</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Customer ID"
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter First Name or Last Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Userrname</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Username"
                        value={username}
                        onChange={(e) => setuserName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Email</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group as={Col} controlId="formName">
                      <Form.Label className="label">Deposit Status</Form.Label>
                      <Form.Select
                        onChange={(e) => setTransType(e.target.value)}
                      >
                        <option value="" disabled selected>
                          Select Deposit Status
                        </option>
                        <option value="0">Pending</option>
                        <option value="1">Approved</option>
                        <option value="2">Hold</option>
                        <option value="3">Cancelled</option>
                        <option value="4">Completed</option>
                        <option value="5">Settled</option>
                        <option value="6">Returned</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group
                      as={Col}
                      controlId="formName"
                      style={{ marginTop: "30px" }}
                    >
                      <Button
                        variant="primary"
                        style={{
                          width: "70%",
                          background: "#0D3862",
                          borderRadius: "8px",
                        }}
                        onClick={() => paymentsData(1, filteredData)}
                      >
                        Search
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
                {/* </div> */}
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        // aria-label="a dense table"
                        stickyHeader
                        // aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Customer ID</TableCell>
                            <TableCell align="center">Username</TableCell>
                            <TableCell align="center">
                              First & Last Name{" "}
                            </TableCell>

                            <TableCell align="center">Transaction ID</TableCell>
                            <TableCell align="center">Email</TableCell>
                            {/* <TableCell align="center">
                              Transaction Type
                            </TableCell> */}
                            <TableCell align="center">Trans Date</TableCell>
                            <TableCell align="center">Amount</TableCell>
                            <TableCell align="center">Status</TableCell>

                            <TableCell align="center">
                              Transaction sources
                            </TableCell>
                            <TableCell align="center">Account Status</TableCell>

                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">
                                {row.id_user}
                              </TableCell>
                              <TableCell align="center">{row.login}</TableCell>

                              <TableCell align="center">
                                {row.name} {row.surname}
                              </TableCell>

                              <TableCell align="center">
                                {row.id_transaction}
                              </TableCell>
                              <TableCell align="center">
                                {row?.email}
                              </TableCell>
                              
                              {/* <TableCell align="center">
                                {row.type == 24 ? "Corepay" : "Skrill"}
                              </TableCell> */}
                              <TableCell align="center">
                                {moment
                                  .utc(row.insertion_time)
                                  .format("YYYY-MM-DD")}
                              </TableCell>
                              <TableCell align="center">
                                {row.tamount}
                              </TableCell>
                              <TableCell align="center">
                                {row.transaction_status}
                              </TableCell>

                              <TableCell align="center">
                                {row.depositSource}
                              </TableCell>
                              <TableCell align="center">
                                {row.accountSatus}
                              </TableCell>
                              <TableCell align="center">
                                {row.ext_status == "RETURNED" &&
                                row.status == "4" ? (
                                  <Button
                                    variant="primary"
                                    className="mrglft10"
                                    style={{
                                      background: "#0D3862",
                                      borderRadius: "8px",
                                    }}
                                    onClick={() => {
                                      refundButton(row);
                                    }}
                                  >
                                    Refund
                                  </Button>
                                ) : (
                                  <div></div>
                                )}

                                {/* </div> */}
                              </TableCell>
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              className="hide-rows-per-page-options"
                              rowsPerPageOptions={[5, 10, 25, 50]}
                              colSpan={12}
                              count={
                                rowsPerPage === -1 ? rows.length : totalcount
                              }
                              rowsPerPage={rowsPerPage}
                              page={page - 1}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Deposit;
